import http from "../../utils/http";
import { toast } from "../../utils/toast";

// 은행계좌 및 내역 엑셀 다운로드
export const downloadBankAccountexcel = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/banks/accounts/excel", body, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


// 은행계좌별 요약정보 리스트 조회
export const getBankAccountSummaryList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/banks/accounts/summaries", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 회사에서 사용하는 은행계좌 목록조회
export const getBankAccountList = (includeDeleted, type, idx, status) => {
  return new Promise((resolve, reject) => {
    http
      .get("/banks/accounts", {
        params: {
          includeDeleted,
          type,
          idx,
          status
        },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 은행내역 은행 별 목록 조회
export const getBankTransRecordList = (
  body,
) => {
  return new Promise((resolve, reject) => {
    http
      .post("/banks/trans/records/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 은행내역 목록 조회
export const getBankTransRecordListEach = (
  body,
) => {
  return new Promise((resolve, reject) => {
    http
      .post("/banks/trans/records/list/each", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 은행내역 목록 조회
export const getBankTransRecordDetail = (idx, companyIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/banks/trans/records/${idx}/detail`, { params: { companyIdx } })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 은행 기타거래 생성
export const createBanksCashAccounts = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/banks/cash-accounts", body)
      .then((res) => {
        toast.success('기타거래가 생성되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 은행 현금 계좌에 입출금 내역 리스트 등록
export const createBanksCashAccountsTransList = (accountNo, body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/banks/cash-accounts/account-no/${accountNo}/trans/list`, body)
      .then((res) => {
        toast.success('기타거래 거래내역 생성되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 은행내역 기타거래 입출금내역 수정
export const modifyBanksCashAccountsTransList = (accountNo, idx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/banks/cash-accounts/account-no/${accountNo}/trans/${idx}`, body)
      .then((res) => {
        toast.success('기타거래 거래내역이 수정되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


// 은행내역 기타거래 입출금내역 리스트 삭제
export const deleteBanksCashAccounts = (accountNo, idxList) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/banks/cash-accounts/account-no/${accountNo}`, {
        data: {
          idxList
        }
      })
      .then((res) => {
        toast.success('기타거래 거래내역이 삭제되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 은행 현금 계좌에 기초잔액 반영
export const createBanksCashAccountsPreBalance = (accountNo, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/banks/cash-accounts/account-no/${accountNo}/pre-balance`, body)
      .then((res) => {
        toast.success('기타거래 기초잔액이 반영되었습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 은행내역 목록에 종속항목 일괄 등록
export const createBanksTransItems = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post('/banks/trans/items', body)
      .then((res) => {
        toast.success('은행내역에 연관데이터를 등록하였습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 은행내역 종속항목 삭제
export const deleteBanksTransItems = (idx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/banks/trans/items/${idx}`)
      .then((res) => {
        toast.success('은행내역에 연관데이터를 삭제하였습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 기타거래 정보 수정
export const modifyCashAccountsInfo = (bankAccountIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/banks/accounts/${bankAccountIdx}`, body)
      .then((res) => {
        toast.success('기타거래 정보를 수정하였습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// ------------------------ 거래처 매핑 ------------------------

// 거래처 매핑 거래처 리스트
export const getClientsList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post('/clients/list', body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 은행내역 목록에 거래처종속 일괄등록
export const createBankTransRecordsClient = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post('/banks/trans/records/clients', body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 은행내역 거래처 삭제
export const deleteBanksTransClients = (idx, clientIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/banks/trans/records/${idx}/clients/${clientIdx}`)
      .then((res) => {
        toast.success('은행내역에 매핑된 거래처를 삭제하였습니다.');
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// ---------------------- 태그 관련 ----------------------
// 매핑 태그 리스트 조회
export const getBankTransMappingTagsList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post('/banks/trans/clients/mapping-tags/list', body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 매핑 태그 등록
export const createBankTransMappingTags = (clientIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/banks/trans/clients/${clientIdx}/mapping-tag`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 매핑 태그 삭제
export const deleteBankTransMappingTags = (mappingTagIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/banks/trans/clients/mapping-tags/${mappingTagIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 은행내역 수정
export const modifyBankTransRecords = (idx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/banks/trans/records/${idx}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 은행내역 기타거래 입출금내역 수정
export const modifyBankTransUseConfirm = (idx, useConfirm) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/banks/trans/records/${idx}/useconfirm`, {
        useConfirm
      })
      .then((res) => {
        toast.success(`내역확인요청 ${useConfirm ? '' : '취소'}되었습니다.`);
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 은행 거래 목록 다운로드
export const getBankTransRecordsDownloads = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/banks/accounts/excel", body, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// 은행 거래 목록 엑셀 메일로 받기
export const getBankTransRecordExcelMailSend = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/banks/accounts/excel/send-mail", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 은행 계좌 목록 다운로드
export const getBankAccountSummariesDownloads = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("banks/accounts/summaries/excel", body, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const sendBankTransRecordsPush = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("banks/trans/records/push", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const uploadCashAccountTransList = (idx, file) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/banks/cash-accounts/account-no/${idx}/trans/excel/upload`, file)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};